// extracted by css-extract-rspack-plugin
export default {"cls1":"NewCitationPing-cls1_Yeb","cls2":"NewCitationPing-cls2_OMt NewCitationPing-cls1_Yeb"};